<template>
  <div class="card">
    <div class="card-body">
      <p>
        <small class="font-weight-bold">{{ $t('dashboard.total-case') }}</small>
      </p>
      <div
        v-if="error"
        class="text-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
        class="row"
      >
        <Bar
          class="col-6 col-md-2"
          :name="$t('dashboard.total-case-label.fever')"
          color-one="#18B2BD"
          color-two="#4C2E88"
          :value="totalCase.Fever"
          :total="totalCase.totalSubmission"
        />
        <Bar
          class="col-6 col-md-2"
          :name="$t('dashboard.total-case-label.symptom')"
          color-one="#18B2BD"
          color-two="#4C2E88"
          :value="totalCase.Symptomps"
          :total="totalCase.totalSubmission"
        />
        <Bar
          class="col-6 col-md-2"
          :name="$t('dashboard.total-case-label.applied')"
          color-one="#18B2BD"
          color-two="#4C2E88"
          :value="totalCase.AppliedProtocol"
          :total="totalCase.totalSubmission"
        />
        <Bar
          class="col-6 col-md-2"
          :name="$t('dashboard.total-case-label.physical')"
          color-one="#18B2BD"
          color-two="#4C2E88"
          :value="totalCase.PhysicalContact"
          :total="totalCase.totalSubmission"
        />
        <Bar
          class="col-6 col-md-2"
          :name="$t('dashboard.total-case-label.travelling')"
          color-one="#18B2BD"
          color-two="#4C2E88"
          :value="totalCase.Traveling"
          :total="totalCase.totalSubmission"
        />
        <Bar
          class="col-6 col-md-2"
          :name="$t('dashboard.total-case-label.visit')"
          color-one="#18B2BD"
          color-two="#4C2E88"
          :value="totalCase.Visit"
          :total="totalCase.totalSubmission"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { format, sub } from 'date-fns'
import Api from '@/utils/Api'
import Bar from '@/components/chart/Bar.vue'

export default {
  components: {
    Bar
  },

  props: {
    filters: {
      type: Object,
      default: () => ({
        period: 'daily',
        startDate: sub(new Date(), { days: 30 }),
        endDate: new Date()
      })
    },
    isApply: {
      type: Boolean,
      default: () => (false)
    }
  },

  data: () => ({
    totalCase: {
      AppliedProtocol: 0,
      PhysicalContact: 0,
      Symptomps: 0,
      Traveling: 0,
      totalSubmission: 0,
      Fever: 0,
      Visit: 0
    },
    error: ''
  }),

  computed: {
    builtFilters () {
      return [
        `period=${this.filters.period}`,
        `startDate=${format(this.filters.startDate, 'yyyy-MM-dd')}`,
        `endDate=${format(this.filters.endDate, 'yyyy-MM-dd')}`,
        ...this.filters.organization.map(organization => `organization=${organization}`),
        ...this.filters.workLocation.map(workLocation => `workLocation=${workLocation}`),
        ...this.filters.employee.map(employee => `employeeType=${employee}`),
        ...this.filters.contractors.map(contractors => `contractorId=${contractors}`),
        ...this.filters.risk.map(risk => `risk=${risk}`)
      ].join('&')
    }
  },

  watch: {
    'filters.contractors': {
      deep: true,
      immediate: true,
      handler: 'fetch'
    },
    isApply: {
      deep: true,
      immediate: true,
      handler: 'fetch'
    }
  },

  created () {
    this.fetch()
  },

  methods: {
    async fetch () {
      try {
        this.error = ''
        const { data } = await Api.dashboard.totalCase(this.builtFilters)
        this.totalCase = data
      } catch ({ response }) {
        this.error = 'Error'
      }
    }
  }
}
</script>
